export default __webpack_public_path__ + "static/media/pen2.48be088e.svg";